import { CustomMeetYourHerbsState } from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomMeetYourHerbsState) => ({
    // productTitle: state.customMeetYourHerbsReducer?.product?.sellable_item["0"].name,
    productTitle: state.customMeetYourHerbsReducer?.productData?.productTitle,
    productDesc: state.customMeetYourHerbsReducer?.productData?.content.htmlContent

});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface MYHProductDetailsPageTitleStyles {
    container?: GridContainerProps;
    brandGridItem?: GridItemProps;
    brandStyles?: ProductBrandStyles;
    titleGridItem?: GridItemProps;
    titleText?: TypographyProps;
    subTitleText?: TypographyProps;
}

export const pageTitleStyles: MYHProductDetailsPageTitleStyles = {
    container: {
        gap: 0,
        offsetCss: css`
            max-width: 100%;
        `,
    },
    brandGridItem: {
        width: 12,
    },
    brandStyles: {
        logoImage: {
            css: css`
                img {
                    max-width: 150px;
                    max-height: 150px;
                }
            `,
        },
        nameText: {
            size: 16,
            weight: "normal",
        },
    },
    titleGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    titleText: {
        variant: "h2",
        size: 32,
        color: "primary",
        css: css`
            width: 100%;
            text-align: left;
            margin-bottom: 20px;
        `,
    },
    subTitleText: {
        variant: "p",
        fontFamily: "LatoMedium",
        css: css`
            width: 100%;
            text-align: left;
            margin-bottom: 20px;
        `,
    },
};

const styles = pageTitleStyles;

const GAIAMYHProductDetailsPageTitle: React.FC<Props> = ({ productTitle, productDesc }) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.titleGridItem}>
                <Typography {...styles.titleText} data-test-selector="productDetails_productDescription">
                    {productTitle}
                </Typography>
                <Typography {...styles.subTitleText}>
                    {productDesc}
                </Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(GAIAMYHProductDetailsPageTitle),
    definition: {
        displayName: "MYH Page Title",
        group: "MYH Product Details" as WidgetGroup,
    },
};

export default widgetModule;
